import './copytoclipboard.css'

import Icons from './icons/Icons';
import { useSuccessNotification } from 'components/hooks/useAppStore';

export const CopyToClipboard = ({ title = "", text = "" }) => {

    const addSuccessNotification = useSuccessNotification();

    const handleCopy = () => {
        navigator.clipboard.writeText(text).then(() => {
            addSuccessNotification("Teksten ble kopiert til utklippstavlen.");
        }).catch(err => {
            console.warn('Failed to copy text: ', err);
        });
    };

    return (
        <div className="copy-to-clipboard pointer" onClick={handleCopy}>
            <div>{title}</div>
            <div><Icons iconName="copy" dimensions={14} /></div>
        </div>
    );
}
